<template>
  <v-card>
    <div style="width: 100%; position: relative;">
      <v-btn
        icon
        style="position: absolute; right: 20px; top: 25px;"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="modal-content">
      <div
        class="d-flex align-center"
        style="gap: 16px;"
      >
        <v-icon
          size="24"
          color="warning"
        >
          {{ icons.mdiAlertOutline }}
        </v-icon>
        <h3 style="font-weight: 600; font-size: 18px;">
          Motivo da aprovação
        </h3>
      </div>
      <div style="margin-top: 16px;">
        <p style="font-weight: 500; font-size: 14px; color: #E7E3FC;">
          Este checklist possui itens não conformes. Para prosseguir com a aprovação, por favor, insira o motivo.
        </p>
      </div>
      <v-form
        ref="form"
        style="margin-top: 32px;"
      >
        <div class="form-group">
          <h3 style="font-weight: 600; font-size: 15px; margin-bottom: 8px;">
            Motivo geral da aprovação
          </h3>
          <v-textarea
            v-model="reason"
            outlined
            dense
            label="Descrição"
            :rules="[rules.required]"
            rows="4"
          />
        </div>
      </v-form>
      <div class="d-flex justify-center">
        <v-btn
          color="success"
          :loading="isLoading"
          @click="handleApprove"
        >
          <div
            class="d-flex align-center"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiThumbUp }}</v-icon>
            <span>APROVAR</span>
          </div>
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mdiAlertOutline, mdiClose, mdiThumbUp } from '@mdi/js'

export default {
  name: 'ApproveChecklistModal',
  data() {
    return {
      icons: {
        mdiClose,
        mdiAlertOutline,
        mdiThumbUp,
      },
      reason: '',
      isLoading: false,
      rules: {
        required: value => !!value || 'Campo obrigatório',
      },
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async handleApprove() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return

      try {
        this.isLoading = true

        // Emitir evento de aprovação com o motivo
        this.$emit('approve', this.reason)

        // Fechar modal
        this.closeModal()
      } catch (error) {
        console.error('Erro ao aprovar checklist:', error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.modal-content {
  padding: 60px 40px 40px 40px;
}

.form-group {
  width: 100%;
}
</style>
